module.exports = __webpack_public_path__ + "static/media/mashable-logo.26d04980.svg";